/**
 * R7E_DebugManager
 * 
 * Manages debug mode state, visibility, and console logging for Recognyze applications.
 */
class R7E_DebugManager {
    enabled = false;
    visible = false;
    observers = [];
    consoleLogEnabled = false;
    uiDebugEnabled = false;
    usingFakeData = false;
    constructor(enabled) {
        this.enabled = enabled ? true : false;
        this.uiDebugEnabled = this.enabled;
        
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                // console.log('R7E_DebugManager, constructor, localStorage', window.localStorage);
                // Get debug mode visibility from localStorage
                this.visible = window.localStorage.getItem('r7e.debug_visible') === '1';                
                // Get console log enabled state from localStorage
                this.consoleLogEnabled = window.localStorage.getItem('r7e.console_log_enabled') === '1';
                // Get UI debug enabled state from localStorage
                this.uiDebugEnabled = window.localStorage.getItem('r7e.ui_debug_enabled') === '1';
                // Get using fake data state from localStorage
                this.usingFakeData = window.localStorage.getItem('r7e.using_fake_data') === '1';
            }
        } catch (e) {
            // Ignore localStorage errors (e.g., in private mode)
        }

        this.notifyObservers({ visible: this.isVisible() });
    }
    isEnabled() { return this.enabled; }
    setEnabled(b) { 
        this.enabled = b ? true : false; 
        this.consoleLogEnabled = this.enabled;
    }
    isUsingFakeData() { return this.enabled && this.usingFakeData; }
    setUsingFakeData(b) { 
        if (this.enabled) {
            this.usingFakeData = b ? true : false; 
        } else {
            this.usingFakeData = false;
        }
        // Remember using fake data state in localStorage
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('r7e.using_fake_data', this.usingFakeData ? '1' : '0');
            }
        } catch (e) {
            // Ignore localStorage errors (e.g., in private mode)
        }
    }
    isConsoleLogEnabled() { return this.enabled && this.consoleLogEnabled; }
    setConsoleLogEnabled(b) { 
        if (this.enabled) {
            this.consoleLogEnabled = b; 
        } else {
            this.consoleLogEnabled = false;
        }
        // Remember console log enabled state in localStorage
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('r7e.console_log_enabled', this.consoleLogEnabled ? '1' : '0');
            }
        } catch (e) {
            // Ignore localStorage errors (e.g., in private mode)
        }
    }
    isUIDebugEnabled() { return this.enabled && this.uiDebugEnabled; }
    setUIDebugEnabled(b) { 
        if (this.enabled) {
            this.uiDebugEnabled = b; 
        } else {
            this.uiDebugEnabled = false;
        }
        // Remember UI debug enabled state in localStorage
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('r7e.ui_debug_enabled', this.uiDebugEnabled ? '1' : '0');
            }
        } catch (e) {
            // Ignore localStorage errors (e.g., in private mode)
        }
    }

    setVisible(b) { 
        // console.log('R7E_DebugManager, setVisible', b);
        this.visible = b ? true : false; 
        // Keep debug mode visibility in localStorage
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('r7e.debug_visible', this.visible ? '1' : '0');
            }
        } catch (e) {
            // Ignore localStorage errors (e.g., in private mode)
        }
        this.notifyObservers({ visible: this.isVisible() });
    }
    isVisible() { return this.visible; }

    registerObserver(cb) { this.observers.push(cb); }
    unregisterObserver(cb) { this.observers = this.observers.filter(o => o !== cb); }
    notifyObservers(b) { 
        // console.log('R7E_DebugManager, notifyObservers', b);
        this.observers.forEach(o => o(b)); 
    }
}

export { R7E_DebugManager };

